import { r as registerInstance, c as createEvent, h, H as Host } from './index-662ec80e.js';
import { p as propCheck, r as runWatchers, h as hasPropError, d as displayPropError } from './propCheck-e7571e3e.js';
import { b as vMinLength, S as vOneOf, a1 as vUndefOr, Q as vBoolean } from './validation-02b8d01d.js';
import { a as buttonVersions } from './types-cf96c64e.js';
import { i as iconNames } from './types-41f9e587.js';
import './i18n-939e2dee.js';
import './types-6f6b2fba.js';

const dsEmptyStateCss = "ds-empty-state{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}ds-empty-state>ds-icon{margin-bottom:1rem !important}ds-empty-state>h5{color:var(--coolGrey-700);font-weight:bold;margin-top:0.25rem !important;margin-bottom:0.25rem !important}ds-empty-state>p{color:var(--grey-900);font-size:0.88888889rem;line-height:1.56rem;margin-bottom:0.25rem !important}ds-empty-state>ds-button{margin-top:1rem !important}";

const DsEmptyState = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.cta = createEvent(this, "cta", 7);
    this.propError = {};
    this.heading = undefined;
    this.text = undefined;
    this.icon = "no-result";
    this.buttonLabel = undefined;
    this.buttonIcon = undefined;
    this.buttonVersion = "primary";
    this.buttonReverse = true;
  }
  watchHeading() {
    /* istanbul ignore if */
    if (!propCheck(this, 'heading', 'string', vMinLength(1)))
      return;
  }
  watchText() {
    /* istanbul ignore if */
    if (!propCheck(this, 'text', 'string', vMinLength(1)))
      return;
  }
  watchIcon() {
    /* istanbul ignore if */
    if (!propCheck(this, 'icon', iconNames.join(" | "), vOneOf(iconNames)))
      return;
  }
  watchButtonLabel() {
    /* istanbul ignore if */
    if (!propCheck(this, 'buttonLabel', 'text | undefined', vUndefOr(vMinLength(1))))
      return;
  }
  watchButtonIcon() {
    /* istanbul ignore if */
    if (!propCheck(this, 'buttonIcon', iconNames.join(" | "), vUndefOr(vOneOf(iconNames))))
      return;
  }
  watchButtonVersion() {
    /* istanbul ignore if */
    if (!propCheck(this, 'buttonVersion', buttonVersions.join(" | "), vOneOf(buttonVersions)))
      return;
  }
  watchButtonReverse() {
    /* istanbul ignore if */
    if (!propCheck(this, 'buttonReverse', 'boolean', vBoolean))
      return;
  }
  connectedCallback() {
    runWatchers(this);
  }
  render() {
    if (hasPropError(this))
      return displayPropError(this);
    return (h(Host, null, h("ds-icon", { name: this.icon, size: "3.5rem", color: "var(--grey-700)" }), h("h5", null, this.heading), h("p", null, this.text), this.buttonLabel &&
      h("ds-button", { label: this.buttonLabel, isReverse: this.buttonReverse, icon: this.buttonIcon, iconSize: "14px", version: this.buttonVersion, onClick: () => this.cta.emit() })));
  }
  static get watchers() { return {
    "heading": ["watchHeading"],
    "text": ["watchText"],
    "icon": ["watchIcon"],
    "buttonLabel": ["watchButtonLabel"],
    "buttonIcon": ["watchButtonIcon"],
    "buttonVersion": ["watchButtonVersion"],
    "buttonReverse": ["watchButtonReverse"]
  }; }
};
DsEmptyState.style = dsEmptyStateCss;

export { DsEmptyState as ds_empty_state };
